<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card class="rounded-xl" flat>
        <v-card-title class="justify-center">{{
          $t("dsLimitationUse.title")
        }}</v-card-title>
        <v-card-text>
          <div class="rowinfo">
            <v-select
              v-model="computedValue.name"
              :items="translatedItems"
              :menu-props="{ offsetY: true }"
              class="rounded-lg"
              dense
              hide-details
              outlined
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-computedValue-name`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('dsLimitationUse.labels.limitation')"
            />
          </div>
        </v-card-text>

        <template v-if="computedValue.name === 'DiscountCode'">
          <v-card-title class="justify-center">{{
            $t("dsLimitationUse.discountCodeTitle")
          }}</v-card-title>
          <v-card-text>
            <div class="rowinfo">
              <v-text-field
                v-model="computedValue.DiscountCode"
                class="rounded-lg contentinfo"
                clearable
                dense
                hide-details
                hide-spin-buttons
                outlined
                type="number"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-DiscountCode`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('dsLimitationUse.labels.usage')"
              />
            </div>
          </v-card-text>
        </template>

        <template v-if="computedValue.name === 'User'">
          <v-card-title class="justify-center">{{
            $t("dsLimitationUse.userTitle")
          }}</v-card-title>
          <v-card-text>
            <div class="rowinfo">
              <v-text-field
                v-model="computedValue.User"
                class="rounded-lg contentinfo"
                clearable
                dense
                hide-details
                hide-spin-buttons
                outlined
                type="number"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-User`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('dsLimitationUse.labels.user')"
              />
            </div>
          </v-card-text>
        </template>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "dsLimitationUse",

  props: {
    value: Object,
  },

  data: () => ({
    helpData: [],
    componentName: "dsLimitationUse",
    serviceName: "Qrland",
  }),

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    translatedItems() {
      return [
        {
          value: "NoLimitations",
          text: this.$t("dsLimitationUse.items.NoLimitations"),
        },
        {
          value: "DiscountCode",
          text: this.$t("dsLimitationUse.items.DiscountCode"),
        },
        { value: "User", text: this.$t("dsLimitationUse.items.User") },
      ];
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    "computedValue.name"(val) {
      if (val === "NoLimitations")
        this.computedValue = {
          name: "NoLimitations",
        };
      else
        this.computedValue = {
          name: val,
          [val]: null,
        };
    },
  },
};
</script>

<style scoped></style>
